<template>
	<div class="data19">
		<div class="data19TilBox">
			<div class="data19Til">{{list.data.menuTitle}}</div>
		</div>
		<div>
			<div class="swiper-hexinTwo" :class="`swiper-hexinTwo${list.index}`">
				<div class="swiper-wrapper">
					<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in list.data.content" :key="indexa">
						<div class="swiper-slideTwo-img">
							<img :src="itema.cover" />
						</div>
						<div class="swiper-slideTwo-name">
							{{itema.title}}
						</div>
						<div class="swiper-slideTwo-cen">
							{{itema.desc}}
						</div>
					</div>
				</div>
				<template v-if="headerShow">
					<div class="swiper-hexin-prev" v-if="list.data.content.length>2" :style="{
						display:prev,
						left:(bj+30)+'px'
					}">
						<img src="@/assets/product/page6/zjt.png" />
					</div>
					<div class="swiper-hexin-next" v-if="list.data.content.length>2" :style="{
						display:next,
						right:(bj+30)+'px'
					}">
						<img src="@/assets/product/page6/yjt.png" />
					</div>
				</template>
				<template v-else>
					<div class="swiper-hexin-prev" v-if="list.data.content.length>1" :style="{
						display:prev,
						left:'30px'
					}">
						<img src="@/assets/product/page6/zjt.png" />
					</div>
					<div class="swiper-hexin-next" v-if="list.data.content.length>1" :style="{
						display:next,
						right:'30px'
					}">
						<img src="@/assets/product/page6/yjt.png" />
					</div>
				</template>
				
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list: [{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		name: '内置SD卡',
				// 		cen: '一键读取存储，随时备份临床素材'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		name: '3.5英寸液晶显示屏',
				// 		cen: '利于便携式操作，适应于各类临床应用场景'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		name: 'LED照明电筒',
				// 		cen: '高亮度、低功耗、长寿命，有效降低内镜头端部温度'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		name: '软硬可调',
				// 		cen: '- 结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度- 可满足结肠不同部位的进镜需求'
				// 	},
				// 	{
				// 		img: require("@/assets/content/hexinBanner.png"),
				// 		name: '随动弯曲',
				// 		cen: '-顺应结肠不同部位的转向，在脾曲肝曲等部位自适应扭转镜身向空腔行进-'
				// 	},
				// ],
				mySwiperTwo: '',
				mySwiper: "",
				innerSwipers: [],
				sliact: 0,
				prev: 'none',
				next: 'block',
				bj: ""
			}
		},
		watch: {
			bj() {
				let t = this;
				// autoplay: {
				// 	delay: 3000,
				// 	disableOnInteraction: false,
				// },
				let name = '.swiper-hexinTwo' + this.list.index;
				if(this.headerShow){
					this.mySwiper = new this.$swiper(name, {
						// 内部Swiper的选项
						direction: 'horizontal',
						widch: 580,
						slidesPerView: 'auto', // 每屏显示3个滑块
						spaceBetween: 40,
						slidesOffsetBefore: this.bj,
						slidesOffsetAfter: this.bj,
						// 自动播放
						autoplay: false,
						navigation: {
							prevEl: ".swiper-hexin-prev",
							nextEl: ".swiper-hexin-next",
						},
						on: {
							slideChangeTransitionEnd: function() {
								if (this.activeIndex === 0) {
									t.prev = 'none';
								} else {
									t.prev = 'block';
								}
								if (this.activeIndex === this.slides.length - 1) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
								if (this.activeIndex === this.slides.length - 2) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
							},
						},
					});
				}else{
					this.mySwiper = new this.$swiper(name, {
						// 内部Swiper的选项
						direction: 'horizontal',
						slidesPerView: 'auto', // 每屏显示3个滑块
						slidesOffsetBefore: this.bj,
						slidesOffsetAfter: this.bj,
						// 自动播放
						autoplay: false,
						navigation: {
							prevEl: ".swiper-hexin-prev",
							nextEl: ".swiper-hexin-next",
						},
						allowTouchMove: this.list.data.content.length > 1 ? true : false,
						on: {
							slideChangeTransitionEnd: function() {
								if (this.activeIndex === 0) {
									t.prev = 'none';
								} else {
									t.prev = 'block';
								}
								if (this.activeIndex === this.slides.length - 1) {
									t.next = 'none';
								} else {
									t.next = 'block';
								}
								// if (this.activeIndex === this.slides.length - 2) {
								// 	t.next = 'none';
								// } else {
								// 	t.next = 'block';
								// }
							},
						},
					});
				}
				
			}
		},
		mounted() {
			let t = this;
			this.getWidth();
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-hexin {
		overflow: hidden;
	}

	.swiper-hexinTwo {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 220px;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;
			cursor: pointer;
		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 220px;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;
			cursor: pointer;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	.swiper-slideTwo {
		position: relative;

		width: 580px;

		.swiper-slideTwo-img {
			width: 580px;
			height: 440px;
			margin-bottom: 34px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.swiper-slideTwo-name {
			font-size: 26px;
			
			font-weight: 400;
			color: #000000;
			margin-bottom: 32px;
		}

		.swiper-slideTwo-cen {
			font-size: 18px;
			
			font-weight: 300;
			color: #000000;
			white-space: pre-line;
		}
	}

	.data19 {
		margin-bottom: 150px;

		.data19TilBox {
			width: 1200px;
			margin: 0 auto;
		}

		.data19Til {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 92px;
		}

		.data19Tab {
			position: relative;
			width: 800px;
			padding-bottom: 35px;
			display: flex;
			align-items: center;
			border-bottom: 2px solid #E5E5E5;
			margin-bottom: 56px;

			.data19TabFor:nth-of-type(1) {
				width: 60%;
			}

			.data19TabFor:nth-of-type(2) {
				width: 20%;
			}

			.data19TabFor:nth-of-type(3) {
				width: 20%;
			}

			.data19TabFor {
				font-size: 26px;
				
				font-weight: 300;
				color: #000000;
				cursor: pointer;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.data19TabXian {
				position: absolute;
				bottom: -1px;
				left: 0;
				width: 60%;
				height: 2px;
				background: #000000;
				transition: all .3s ease-in-out;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data19 {
			margin-bottom: 0px !important;
			padding: 0 30px 0px !important;
			box-sizing: border-box;

			.data19TilBox {
				width: 100% !important;
			}

			.data19Til {
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
		}

		.swiper-slideTwo {
			max-width: 100% !important;

			.swiper-slideTwo-img {
				max-width: 100% !important;
				margin-bottom: 20px !important;
				object-fit: contain !important;
				height: auto !important;
			}

			.swiper-slideTwo-name {
				font-size: 18px !important;
				margin-bottom: 20px !important;
			}

			.swiper-slideTwo-cen {
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}
		}
		
	}
</style>